import getLocal from '@/app/utils/getLocal';
import EcoTextTc, { EcoTextTcItemProps } from 'eco-design/sections/eco-text-tc';
import styles from './index.module.scss';
import { tcLang } from './lang';

export default function Comp() {
    const { locale } = getLocal();
    const tcLanguage = tcLang[locale] || tcLang['eu'];

    let items: EcoTextTcItemProps[] = [
        // {
        //     isHead: true,
        //     title: tcLanguage.head1,
        // },
        {
            title: tcLanguage.titleA1,
            desc: tcLanguage.descA1,
            isOpen: true,
        },
        {
            title: tcLanguage.titleA2,
            desc: tcLanguage.descA2,
        },
        {
            title: tcLanguage.titleA3,
            desc: tcLanguage.descA3,
        },
        {
            title: tcLanguage.titleA4,
            desc: tcLanguage.descA4,
        },
    ];

    if (locale === 'us') {
        items = [{ title: tcLanguage.title, desc: tcLanguage.desc, isOpen: true }, ...items.map((i) => ({ ...i, isOpen: false }))];
    }

    return (
        <div id="smart-gateway-FooterTcA" className="GtmModuleData-section" data-section-id={'smart-gateway-FooterTcA'} data-section-title={tcLanguage.head1}>
            <EcoTextTc items={items} className={styles.comp} theme="white" />
        </div>
    );
}
